import styled from '@emotion/styled';
import { useCalibration } from '../../context/calibrationContext';
import { colors } from '../../ui';
import { Legend, LabelledValue, ValueBox } from '../../screens/optician/testScreenKit';

// Stroke Suite live key + values (logMAR, distance, quadrant, response). Colours match the
// 2022-component-library VisualFieldMatrix dots.
export const NEURO_DOT_COLORS = {
  correct: '#6DC89D',
  incorrect: '#870000',
  missedOnce: '#F0B729',
  missedTwice: '#FF0000',
  toBeDisplayed: '#AAB2B2',
  outOfBounds: '#F2E6E6',
};

const Values = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
  width: 100%;
`;

const NeuroSuiteInfo = ({ boundariesWarning, totalDots, testProgressData }) => {
  const {
    calibrationData: { distanceFromScreen },
  } = useCalibration();

  const calculateDotsForDisplay = () => {
    const { testEnded, orientationCorrect, orientationIncorrect, missedTwiceDots } = testProgressData;
    if (testEnded) return 0;
    return totalDots - orientationCorrect?.length - orientationIncorrect?.length - missedTwiceDots?.length;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }} data-testid='neuro-info'>
      <Legend
        items={[
          { color: NEURO_DOT_COLORS.correct, label: `Orientation Correct (${testProgressData?.orientationCorrect?.length || 0})` },
          { color: NEURO_DOT_COLORS.incorrect, label: `Orientation Incorrect (${testProgressData?.orientationIncorrect?.length || 0})` },
          { color: NEURO_DOT_COLORS.missedOnce, label: `Not Seen Once (${testProgressData?.missedOnceDots?.length || 0})` },
          { color: NEURO_DOT_COLORS.missedTwice, label: `Not Seen Twice (${testProgressData?.missedTwiceDots?.length || 0})` },
          { color: NEURO_DOT_COLORS.toBeDisplayed, label: `To Be Displayed (${calculateDotsForDisplay() || 0})` },
          ...(!boundariesWarning ? [{ color: NEURO_DOT_COLORS.outOfBounds, label: 'Out of Bounds' }] : []),
        ]}
      />
      <Values>
        <LabelledValue label='logMAR'>
          <ValueBox muted>{`${testProgressData?.logmarSize?.toFixed(1) || '1.0'}`}</ValueBox>
        </LabelledValue>
        <LabelledValue label='Distance'>
          <ValueBox muted>{`${distanceFromScreen ? Math.round(distanceFromScreen) : '--'}mm`}</ValueBox>
        </LabelledValue>
        <LabelledValue label='Quadrant'>
          <ValueBox>{testProgressData?.currentLandoltCQuadrant || '--'}</ValueBox>
        </LabelledValue>
        <LabelledValue label='Response'>
          <ValueBox style={{ color: testProgressData?.patientQuadrantResponse ? colors.primary : undefined }}>{testProgressData?.patientQuadrantResponse || '--'}</ValueBox>
        </LabelledValue>
      </Values>
    </div>
  );
};

export default NeuroSuiteInfo;
